// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  category_vendor_code: yup.string().label("Category vendor code").required(),
  category_vendor_name: yup.string().label("Category vendor name").required()
})